<template>
  <b-col
    :lg="whichPage === 'listings' || whichPage === 'list_event' ? 12 : 4"
    class="d-flex align-items-center auth-bg px-2 p-lg-2 text-din-regular"
  >
    <b-col
      sm="8"
      md="6"
      lg="12"
      class="px-xl-2 mx-auto"
    >
      <b-card-title
        title-tag="h2"
        class="font-weight-bold mb-1"
      >
        Sign In
      </b-card-title>
      <b-card-text class="mb-2">
        Welcome back, please sign in to your account.
      </b-card-text>

      <!-- form -->
      <validation-observer ref="loginForm">
        <b-form
          class="auth-login-form mt-2"
          @submit.prevent
        >
          <!-- email -->
          <b-form-group
            label="Email Address"
            label-for="login-email"
          >
            <validation-provider
              #default="{ errors }"
              name="Email Address"
              rules="required|loginId"
            >
              <b-form-input
                id="login-email"
                v-model="userEmail"
                :state="errors.length > 0 ? false : null"
                name="login-email"
                placeholder="user@example.com"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- forgot password -->
          <b-form-group>
            <div class="d-flex justify-content-between">
              <label for="login-password">Password</label>
              <b-link
                v-if="!isHiringManager"
                :to="
                  userEmail.length > 4
                    ? '/auth/forgot?email=' + userEmail
                    : '/auth/forgot'
                "
              >
                <small>Forgot Password?</small>
              </b-link>
            </div>
            <validation-provider
              #default="{ errors }"
              name="Password"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="login-password"
                  v-model="password"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  name="login-password"
                  placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- checkbox -->
          <b-form-group v-if="!isHiringManager">
            <b-form-checkbox
              id="remember-me"
              v-model="rememberMe"
              name="checkbox-1"
            >
              Remember Me
            </b-form-checkbox>
          </b-form-group>

          <!-- submit buttons -->
          <SpinnerBtn v-if="isLoading" />
          <b-button
            v-else
            id="buttonLogin"
            class="text-din-black"
            :disabled="loginText === 'Sign In' ? false: true"
            type="submit"
            variant="primary"
            block
            @click="validationForm">
            {{ loginText }}
          </b-button>
        </b-form>
      </validation-observer>

      <b-card-text
        v-if="whichPage == 'normal' && !isHiringManager"
        class="text-center mt-2"
      >
        <span>New on our platform? </span>
        <b-link :to="{ name: 'auth-registration' }">
          <span>&nbsp;Create an account</span>
        </b-link>

      </b-card-text>
      <b-card-text
        class="text-center mt-1"
      >
        <b-link :to="{ name: 'listings-event' }">
          <span>Back to Home</span>
        </b-link>
      </b-card-text>
    </b-col>
  </b-col>
</template>

<script>
/* eslint-disable global-require */
import { find } from 'lodash'
import platform from 'platform'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BForm,
  BButton,
} from 'bootstrap-vue'
import { required, email, loginId } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SpinnerBtn from '@/layouts/components/spinners/SpinnerButton.vue'
import useJwt from '@/auth/jwt/useJwt'
import { isUserLoggedIn } from '@/auth/utils'

export default {
  components: {
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BForm,
    BButton,
    SpinnerBtn,

    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  props: {
    whichPage: { type: String, default: 'normal' },
    eventId: { type: String, default: '' },
    isHiringManager: { type: Boolean, default: false },
  },
  data() {
    return {
      newSession: false,
      rememberMe: false,
      password: '',
      userEmail: '',
      isLoading: false,
      score: 1.0,
      loginText: 'Sign In',
      required,
      email,
      loginId,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    score(old, newVal) {
      if (newVal < 0.4) {
        this.loginText = 'Refresh this page or try again later'
      }
    },
  },
  created() {
    // this.recaptcha()
  },
  methods: {
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login')
      // console.log(token)
      const recaptch = this.$recaptchaInstance
      recaptch.hideBadge()

      this.$http
        .get(`/api/auth/recaptcha/${token}`)
        .then(response => {
          const responseData = response.data
          if (responseData.success) {
            const userScore = responseData.score
            this.score = userScore
            if (this.score < 0.4) {
              this.loginText = 'Refresh this page or try again later'
            }
          }
        }).catch(error => {
        })

      // Do stuff with the received token.
    },
    alreadyLoggedInNotifier() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Login Attempt',
            icon: 'AlertCircleIcon',
            text: 'You are already logged in!',
            variant: 'warning',
          },
        },
        { timeout: this.$longestTimeout },
      )
    },
    checkLogin() {
      // If user is already logged in notify
      if (isUserLoggedIn() && !this.isHiringManager) {
        // Close animation if passed as this
        this.alreadyLoggedInNotifier()
        return false
      }
      if (this.isHiringManager) {
        if (
          this.userEmail.toLowerCase()
          === this.$store.state.auth.ActiveUser.email_address.toLowerCase()
        ) {
          this.alreadyLoggedInNotifier()
          return false
        }
        const OtherProfiles = JSON.parse(localStorage.getItem('OtherProfiles'))
          || this.$store.state.OtherProfiles

        const result = find(OtherProfiles, {
          email_address: this.userEmail.toLowerCase(),
        })

        if (result) {
          if (result.email_address === this.userEmail.toLowerCase()) {
            this.alreadyLoggedInNotifier()
          } else {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'Login Attempt',
                  icon: 'AlertCircleIcon',
                  text: 'You have already logged in to this account.',
                  variant: 'warning',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
          return false
        }
        return true
      }
      return true
    },
    twoFactorChecker() {
      localStorage.setItem('email', this.userEmail)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Account Authentication',
          icon: 'AlertCircleIcon',
          text: 'Please check your email address to get your two factor code.',
          variant: 'danger',
        },
      })

      if (!this.isHiringManager) {
        this.$router.push('/authorise')
      } else {
        throw new Error('Two factor code required')
      }
    },
    confirmAccountChecker(userData) {
      let appliedJob = localStorage.getItem('applied_job')
      appliedJob = appliedJob ? JSON.parse(localStorage.getItem('applied_job')) : null

      if (this.isHiringManager) {
        this.$store.commit('auth/UPDATE_MULTIPLE_PROFILES', userData, {
          root: true,
        })
      } else {
        // Set accessToken
        useJwt.setToken(userData.token)
        this.$emit('login-state', true)
        // localStorage.setItem('accessToken', userData.token) // Update user details
        this.$store.commit('auth/UPDATE_USER_INFO', userData, { root: true }) // Set bearer token in axios

        let link = '/my-applications'
        if (
          userData.account_type === this.$AccountTypes.EMPLOYER
          || userData.account_type === this.$AccountTypes.TEMPORARY
          || userData.account_type === this.$AccountTypes.AGENCY
        ) {
          link = '/applicant-tracking'
        }
        // else if (appliedJob) {
        //   link = `/events/${appliedJob._id}?quiz=true`
        // }
        if (this.whichPage !== 'normal') {
          // this.$router.push(this.$router.currentRoute.query.redirect || link)
          if (this.$route.name.includes('listings-page') || this.$route.name === 'page-event') {
            this.$emit('user-logged-in', userData)
          } else {
            this.$emit('user-logged-in', userData)
          }
        } else if (this.$route.name !== 'app-login') {
          // this.$router.push(this.$router.currentRoute.query.redirect || link)

          // * for some reason recirecting with this.$router.push() does not trigger .removeEventListener resulting in multiple listener created and posting multiple same click record
          const hostUrl = window.location.origin
          window.location.replace(`${hostUrl}${this.$router.currentRoute.query.redirect || link}`)
        } else {
          this.$router.push(`${this.$route.fullPath}&approved=true`)
        }
      }
    },
    sessionChecker() {
      this.$bvModal
        .msgBoxConfirm(
          'We have detected that you are signed in on another device/ browser. Do you want to sign in on this device / browser and log out the other one ? ',
          {
            title: 'Multiple sessions alert',
            size: 'sm',
            okVariant: 'primary',
            okTitle: 'Yes',
            cancelTitle: 'No',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(value => {
          if (value) {
            this.$socket.client.emit('force_logout', {
              email_address: this.userEmail,
              user_agent: navigator.userAgent,
            })

            // this.newSession = true
            this.initializeJWT('Unknown', 'Unknown')
            this.$emit('login-state', true)
          } else {
            localStorage.removeItem('userInfo')
            localStorage.removeItem('accessToken')
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'Multiple Sessions Alert',
                  icon: 'AlertCircleIcon',
                  text: 'You have cancelled signing in to this device / browser successfully.',
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
        }).catch(err => {
          console.err(err)
        })
    },

    expiredPasswordChecker(userData) {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('accessToken')
      this.$router.push(userData.link)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Password Expiry',
            icon: 'AlertCircleIcon',
            text: 'Your previous password has already expired.You can reset your password below',
            variant: 'danger',
          },
        },
        { timeout: this.$longestTimeout },
      )
    },

    initializeJWT(location, ipAddress) {
      const userDetails = {
        user: {
          email_address: this.userEmail,
          password: this.password,
          location,
          new_session: this.newSession,
          platform,
          ip_address: ipAddress,
          tracking_id: localStorage.getItem('tracking_id'),
        },
      }
      setTimeout(() => {
        useJwt
          .login(userDetails)
          .then(response => {
            const userData = response.data
            this.isLoading = false
            if (response.data.deactivated) {
              this.$toastDanger('Authentication Error', response.data.message)
              return
            }
  
            // useJwt.setRefreshToken(response.data.refreshToken)
            if (!this.isHiringManager) {
              localStorage.removeItem('userInfo')
              localStorage.removeItem('accessToken')
            }
            if (userData.two_factor) {
              this.twoFactorChecker()
            } else if (userData.token) {
              this.confirmAccountChecker(userData)
              // if (userData.account_approved) {
              //   this.confirmAccountChecker(userData)
              // } else {
              //   this.$toast(
              //     {
              //       component: ToastificationContent,
              //       props: {
              //         title: 'Account Confirmation',
              //         icon: 'AlertCircleIcon',
              //         text: 'Before you can login please check your email address to confirm your account.',
              //         variant: 'warning',
              //       },
              //     },
              //     { timeout: this.$longestTimeout },
              //   )
              // }
            } else if (userData.expired) {
              this.expiredPasswordChecker(userData)
            } else if (userData.show_session) {
              this.sessionChecker(userDetails)
            } else if (userData.deactivated_on) {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: 'Authentication Error',
                    icon: 'AlertCircleIcon',
                    text: userData.errors,
                    variant: 'danger',
                  },
                },
                { timeout: this.$longestTimeout },
              )
            } else {
              this.$toast(
                {
                  component: this.$toastContent,
  
                  props: {
                    title: 'Authentication Error',
                    icon: 'AlertCircleIcon',
                    text: 'Wrong email or password',
                    variant: 'danger',
                  },
                },
                { timeout: this.$longestTimeout },
              )
            }
          })
          .catch(error => {
            this.isLoading = false
            this.$toast(
              {
                component: this.$toastContent,
  
                props: {
                  title: 'Authentication Error',
                  icon: 'AlertCircleIcon',
                  text: 'Wrong email or password',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          })
      }, 0)
    },

    proceedLogin() {
      this.isLoading = true
      this.userEmail = this.userEmail.toLowerCase()
      this.initializeJWT()
    },

    validationForm() {
      // this.recaptcha()
      if (!this.checkLogin()) return

      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.proceedLogin()
        } else {
          this.isLoading = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sign In Error',
              icon: 'AlertCircleIcon',
              text: 'Please correct all the form errors before proceeding',
              variant: 'danger',
            },
          })
        }
      })
    },

    fakeLogin() {
      let userInfo = {
        "created_on":"2023-03-17T18:37:14.884675",
        "updated_on":"2023-03-24T19:50:26.206049",
        "id":"2b3b6394-fe08-490c-8e52-b27a50c47e6d",
        "fullname":"recruit_4",
        "nric_no":null,
        "email_address":"recruit4@e2i.com.sg",
        "alias_email_address":null,
        "phone_number":12341118,
        "profile_image":null,
        "account_type":"agency",
        "user_group":["admin", "superuser"],
        "additional_companies":null,
        "position_in_company":null,
        "gender":null,
        "team":null,
        "date_of_birth":null,
        "citizenship":null,
        "employment_status":null,
        "preferred_position":null,
        "preferred_location":null,
        "preferred_industry":null,
        "highest_qualification":null,
        "postal_code":573819,
        "telegram_id":null,
        "two_factor_active":false,
        "latest_two_factor_code":null,
        "email_verified":false,
        "phone_number_verified":false,
        "password_expired":false,
        "password_expires_on":"2023-09-13T18:37:15.110378",
        "latest_account_confirmation_code":null,
        "access_allowed":true,
        "resume_file":null,
        "last_login":"2023-05-18T14:55:01.646054",
        "availability_number":null,
        "availability_period":null,
        "account_approved":true,
        "account_approval_status":null,
        "company_id":"bbe073da-782b-4105-90e1-4dd1b638d734",
        "login_attempts":0,
        "deactivated_by":null,
        "deactivated_on":null,
        "reactivated_by":null,
        "reactivated_on":null,
        "authorised_ip_address":[],
        "role_id":null,
        "permissions":[{"title":"Analytics","section":"Analytics","read":true,"update":true,"unique_name":"Analytics","sub_section":null,"write":true,"delete":true},{"title":"ATS System","section":"ATS System","read":true,"update":true,"unique_name":"ATS System","sub_section":null,"write":true,"delete":true},{"title":"Audit Log","section":"Audit Log","read":true,"update":true,"unique_name":"Audit Log","sub_section":null,"write":true,"delete":true},{"title":"Corporate Directory","section":"Corporate Directory","read":true,"update":true,"unique_name":"Corporate Directory","sub_section":null,"write":true,"delete":true},{"title":"Data Manager","section":"Data Manager","read":true,"update":true,"unique_name":"Data Manager","sub_section":null,"write":true,"delete":true},{"title":"Events Manager","section":"Events Manager","read":true,"update":true,"unique_name":"Events Manager","sub_section":null,"write":true,"delete":true},{"title":"Finance","section":"Finance","read":true,"update":true,"unique_name":"Finance","sub_section":null,"write":true,"delete":true},{"title":"Recruitment Chatbot","section":"Recruitment Chatbot","read":true,"update":true,"unique_name":"Recruitment Chatbot","sub_section":null,"write":true,"delete":true},{"title":"User Manager","section":"User Manager","read":true,"update":true,"unique_name":"User Manager","sub_section":null,"write":true,"delete":true}],
        "tokens":[],
        "token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbF9hZGRyZXNzIjoicmVjcnVpdDRAZTJpLmNvbS5zZyIsImV4cCI6MTY4NTAwMTMwMSwic3ViIjoiYWNjZXNzIn0.3ZoYtq42T0ZxGpMMlrpv-AOlFWQFeSvjf7y1oOZD_lQ",
        "company_name": 'HEADHUNTERS HQ',
        "company_uen_no": '201721612D',
        "days_left":"in 4 months",
        "nric_available":null,
        "organization":null,
        "profile_status":null
      }
      if (this.userEmail.toLowerCase().includes('administrator')) {
        userInfo.fullname = 'administrator'
        userInfo.account_type = 'agency'
        userInfo.email_address = this.userEmail
        localStorage.setItem('userInfo', JSON.stringify(userInfo))

        this.$router.push({name: 'candidates-data'})
      } else if (this.userEmail.toLowerCase().includes('job_seeker')) {
        userInfo.fullname = 'Job Seeker'
        userInfo.account_type = 'applicant'
        userInfo.user_group = ['applicant']
        userInfo.email_address = this.userEmail
        localStorage.setItem('userInfo', JSON.stringify(userInfo))

        this.$router.push({name: 'manage-applications'})
      } else if (this.userEmail.toLowerCase().includes('employer')) {
        userInfo.fullname = 'employer'
        userInfo.account_type = 'employer'
        userInfo.user_group = ['employer', 'superuser']
        userInfo.email_address = this.userEmail
        localStorage.setItem('userInfo', JSON.stringify(userInfo))

        this.$router.push({name: 'candidates-data'})
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
